import PageTitle from '../components/PageTitle';
import FdmContent from '../components/FdmContent';

export default function FdmPage() {
  return <><PageTitle>vWZZ - Flight Data Monitoring</PageTitle><FdmContent /></>;
}
